/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Front_Desc5Inputs */

const en_svc_rag_knowledge_assistants_front_desc5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed on your site or serve answers where the team already chats.`)
};

const ar_svc_rag_knowledge_assistants_front_desc5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ضمّنه في موقعك أو قدم الإجابات حيث يتحدث الفريق أصلا.`)
};

const bn_svc_rag_knowledge_assistants_front_desc5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার সাইটে বসান বা টিম যেখানে এমনিতেই চ্যাট করে সেখানে উত্তর দিন।`)
};

const de_svc_rag_knowledge_assistants_front_desc5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Ihrer Website einbetten oder Antworten dort liefern, wo das Team ohnehin chattet.`)
};

const es_svc_rag_knowledge_assistants_front_desc5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incrustar en su sitio o responder donde el equipo ya conversa.`)
};

const fr_svc_rag_knowledge_assistants_front_desc5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégrez sur votre site ou répondez là où l'équipe discute déjà.`)
};

const pt_svc_rag_knowledge_assistants_front_desc5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorpore no seu site ou responda onde a equipe já conversa.`)
};

const zh_svc_rag_knowledge_assistants_front_desc5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`嵌入你的网站，或在团队本来聊天的地方作答。`)
};

const tr_svc_rag_knowledge_assistants_front_desc5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitenize gömün ya da ekibin zaten sohbet ettiği yerde yanıtlayın.`)
};

const ru_svc_rag_knowledge_assistants_front_desc5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встройте на свой сайт или отвечайте там, где команда уже общается.`)
};

const pl_svc_rag_knowledge_assistants_front_desc5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Front_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osadź na stronie albo odpowiadaj tam, gdzie zespół i tak już gada.`)
};

/**
* | output |
* | --- |
* | "Embed on your site or serve answers where the team already chats." |
*
* @param {Svc_Rag_Knowledge_Assistants_Front_Desc5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_front_desc5 = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Front_Desc5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Front_Desc5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_front_desc5(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_front_desc5(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_front_desc5(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_front_desc5(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_front_desc5(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_front_desc5(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_front_desc5(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_front_desc5(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_front_desc5(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_front_desc5(inputs)
	return en_svc_rag_knowledge_assistants_front_desc5(inputs)
});
export { svc_rag_knowledge_assistants_front_desc5 as "svc_rag-knowledge-assistants_FRONT_desc" }